var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 7.5,
  r: 3.6,
  fill: "#f2c14e"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m38 1.2v1.6m4.5 0.9-1.1 1.1m3 5.2h-1.6m-10.8-6.3 1.1 1.1m-2.9 5.2h1.6",
  stroke: "#f2c14e",
  strokeWidth: 1.4,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.8,
  cy: 15.5,
  r: 6,
  fill: "#57b368"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.8,
  cy: 19.5,
  r: 4.2,
  fill: "#3f8f4f"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.8,
  cy: 19.5,
  r: 4.2,
  fill: "#3f8f4f"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 22.5,
  width: 2.6,
  height: 13.5,
  fill: "#8a6238"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 20.5,
  width: 16,
  height: 2,
  rx: 1,
  fill: "#c8925a"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 26.5,
  width: 16,
  height: 2.4,
  rx: 1.1,
  fill: "#c8925a"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 25.5,
  y: 22.5,
  width: 1.6,
  height: 4,
  fill: "#5c6870"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 36.9,
  y: 22.5,
  width: 1.6,
  height: 4,
  fill: "#5c6870"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 25.5,
  y: 28.9,
  width: 1.6,
  height: 7.1,
  fill: "#5c6870"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 36.9,
  y: 28.9,
  width: 1.6,
  height: 7.1,
  fill: "#5c6870"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 36,
  width: 39,
  height: 1.5,
  rx: 0.75,
  fill: "#c3ccd2"
});

function SvgOutdoorCourtyard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoorCourtyard);
export default __webpack_public_path__ + "static/media/outdoor-courtyard.a991e4639a02b6680f74b4614616804c.svg";
export { ForwardRef as ReactComponent };